import axios from "axios";
import { deleteAxios, getAxios, patchAxios, postAxios } from "./api.service";
import { apiNames } from "./endpoint.service";
let urlBeforeRedsys: string = ""

export function setNavigate( url?:string ){  
    let _url=url as any;
    if(url!=""){
    window.sessionStorage.setItem('raas-navigate', url as string);
    }
    urlBeforeRedsys = _url ? _url : window.location.pathname;

}

export function navigateAfterRedsys(){
    if(sessionStorage.getItem('raas-navigate')){
        urlBeforeRedsys=sessionStorage.getItem('raas-navigate')?.toString() as string
    }
    window.location.pathname = urlBeforeRedsys;
    urlBeforeRedsys = "";
}

export function getPaymentMethods() {
    return new Promise((resolve, reject) => {
        return getAxios(apiNames.FINANCIAL, true, "/payment-methods")
            // return axios.get("https://raasmock.herokuapp.com/getPaymentMethods")
            .then((response: any) => {
                // Mock response: 
                // response = {"data": [                   
                //         {
                //             "id": "eyJpZCI6IjBiMTc5MzczLWNmYjQtNDIwNC1hNmFiLTkwNTkxZmYyMGUzYiIsInR5cGUiOiJDUkVESVRfQ0FSRCJ9",
                //             "customerId": "cac429ec-41aa-4505-98d1-ba35a3530ebf",
                //             "type": "CREDIT_CARD",
                //             "default": false,
                //             "deletable": true,
                //             "blocked": false,
                //             "details": {
                //                 "maskedNumber": "454881******1234",
                //                 "network": "VISA",
                //                 "expireDate": "2023-12-31"
                //             }
                //         },
                //         {
                //             "id": "eyJpZCI6ImI3ZTQ4YTAyLTA1NjQtNDUwNS05OWYyLTczYmUyNWQ1N2U2NCIsInR5cGUiOiJDUkVESVRfQ0FSRCJ9",
                //             "customerId": "cac429ec-41aa-4505-98d1-ba35a3530ebf",
                //             "type": "CREDIT_CARD",
                //             "default": true,
                //             "deletable": true,
                //             "blocked": false,
                //             "details": {
                //                 "maskedNumber": "541008******5678",
                //                 "network": "MASTERCARD",
                //                 "expireDate": "2049-12-31"
                //             }
                //         },
                //         {
                //             "id": "eyJpZCI6IjFjZmFmZDk4LTVkNGEtNDRhZC1hZmYwLWQ5YWQzNTc5NzlhZSIsInR5cGUiOiJDUkVESVRfQ0FSRCJ9",
                //             "customerId": "cac429ec-41aa-4505-98d1-ba35a3530ebf",
                //             "type": "CREDIT_CARD",
                //             "default": false,
                //             "deletable": true,
                //             "blocked": false,
                //             "details": {
                //                 "maskedNumber": "454881******91011",
                //                 "network": "VISA",
                //                 "expireDate": "2049-12-31"
                //             }
                //         }
                //     ]
                // }
          
                return resolve(response.data)
            })
            .catch(reject)
    })
}

export function addCard(){
    return new Promise((resolve, reject) => {
        // return axios.get("https://raasmock.herokuapp.com/addCreditCard")
        return postAxios(apiNames.FINANCIAL, true, "/payment-methods?source=web", {paymentMethodType:"CREDIT_CARD"})
        .then((response:any)=>resolve(response.data))
        .catch(reject)
    })
}

export function deleteCard( id:string ){
    return new Promise((resolve, reject) => {
        // return axios.get("https://raasmock.herokuapp.com/deletePaymethod")
        return deleteAxios(apiNames.FINANCIAL, true, "/payment-methods/"+id)
        .then(()=>resolve({status:"ok"}))
        .catch(reject)
    })
}

export function defaultCard( id:string, body:any ){
    return new Promise((resolve, reject) => {
        // return axios.get("https://raasmock.herokuapp.com/checkRollout")
        return patchAxios(apiNames.FINANCIAL, true, "/payment-methods/"+id, body)
        .then(()=>resolve({status:"ok"}))
        .catch(reject)
    })
}


export function confirmationCIT(customers:any,orders:any,processId:any){
    return new Promise((resolve, reject) => {
        return getAxios(apiNames.BKING, true, `/orders/confirmation/ok/customers/${customers}/orders?orderId=${orders}&processId=${processId}`,)
        .then((response:any)=>resolve(response.data))
        .catch(reject)
    })
}



export function confirmationPaymentCIT(orders:any,callback: Function, errorCallback: Function,loader:boolean){
    return getAxios(apiNames.BKING, true, `/bookings/${orders}`,loader).then((data: any) => {
        callback(data);
      }).catch((error: any) => {
        errorCallback(error)
      })
    
}